import images from "../../images";


function AboutMe(props) {
    return (
       <div id = "about-me-wrapper" className= {props.aboutme?'info-subpage-wrapper':'page-hidden'}> 
         {/* <!-- TITLE --> */}
       
        
        {/* ABOUT SECTION */}
         {/* MY INFO SUMMARY */}
         <div id="status-wrapper-aboutme-positioner" className="about-me">
            <div  className="aboutme-status-wrapper">
            <p id="status-title">about</p>
                <div className = "status">
                <div className = "status-message" id="about-me-description">
                   <p>i actually moved everything that was in here to the home page so idk what to put here</p>
                </div>
                </div>
            </div>
           
            {/* MY BUTTON */}
            <div id="status-wrapper-button-positioner" className="aboutme-status-wrapper">
            <p id="status-title">button</p>
                <div className = "status">
                <div className = "status-message" id="button-container">
                     <div id = "site-button">
                        <a href="https://marketchipping.xyz" title="marketchipping.xyz"><img src={images.button.url} width="88" height="31"/></a>
                    </div>
                    <textarea id="code-snippet" rows="2" cols="11" readOnly="">
                        {'<a href="https://marketchipping.xyz" title="marketchipping.xyz"><img src="http://marketchipping.xyz/images/marketchipping.gif" width="88" height="31"/></a>'}
                    </textarea>
                </div>
                </div>
            </div>
             
          </div>
          <div id="pagedoll">
                <img src={images.aya.url}></img>
            </div>
          </div>
    );
  }

  export default AboutMe;